<template>
  <button
    type="button"
    class="theme-toggle"
    :title="label"
    :aria-label="label"
    :aria-pressed="String(isLight)"
    @click="toggleTheme"
  >
    <i :class="isLight ? 'el-icon-moon' : 'el-icon-sunny'" aria-hidden="true"></i>
  </button>
</template>

<script>
import { themeState, toggleTheme } from '../utils/theme';

export default {
  computed: {
    isLight() { return themeState.current === 'light'; },
    label() { return this.isLight ? '切换为深色主题' : '切换为浅色主题'; }
  },
  methods: { toggleTheme }
};
</script>

<style scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid var(--solar-border, rgba(63, 184, 255, 0.45));
  border-radius: 50%;
  background: var(--solar-surface, #002b4d);
  color: var(--solar-text, #b0e2ff);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
.theme-toggle i { font-size: 18px; }
.theme-toggle:hover {
  border-color: var(--solar-primary, #00ccff);
  background: var(--solar-hover, #003c66);
}
.theme-toggle:focus-visible {
  outline: 2px solid var(--solar-primary, #00ccff);
  outline-offset: 3px;
}
@media (max-width: 760px) {
  .theme-toggle { width: 36px; height: 36px; }
}
@media (max-width: 360px) {
  .theme-toggle { width: 34px; height: 34px; }
}
</style>
